angular.module('qkr')
    .controller('marketingController', ($scope, $window, appConfig, outlet, remoteLinks) => {
        const vm = $scope;

        vm.init = function() {
            vm.howtoHiResCanteenUrl = appConfig.apiUrl + 'pdf/get?pdfName=howtoGuideCanteenHiRes';
            vm.howtoLowResCanteenUrl = appConfig.apiUrl + 'pdf/get?pdfName=howtoGuideCanteenLowRes';
            vm.howtoHighResNonCanteenUrl = appConfig.apiUrl + 'pdf/get?pdfName=howtoGuideNonCanteenHiRes';
            vm.howtoLowResNonCanteenUrl = appConfig.apiUrl + 'pdf/get?pdfName=howtoGuideNonCanteenLowRes';
            vm.hasLogoBeenSet = Boolean(outlet.logoUrl);
            vm.remoteLinks = remoteLinks;
            vm.scannableLink = `qkr://qkr.mastercard.com/qkr2/lookup?scanId=${outlet.options.defaultScanId}`;
        };

        vm.getAmazonFile = function(documentName, isMerchantSpecific) {
            $window.location.href = appConfig.apiUrl + 'amazon/get?merchantSpecific=' + isMerchantSpecific +
                '&documentName=' + documentName;
        };
    });



// WEBPACK FOOTER //
// ./src/controllers/marketing.controller.js